import AscDrawer, { AscDrawerProps } from "../AscDrawer/AscDrawer";
import styles from "./AscNotificationDrawer.module.scss";
import AscNotificationContent from "./AscNotificationContent";

export interface AscNotificationDrawerProps
  extends Omit<AscDrawerProps, "children"> {
  notificationsLabel?: string;
}

export default function AscNotificationDrawer({
  notificationsLabel = "Notifications",
  ...rest
}: AscNotificationDrawerProps) {
  return (
    <AscDrawer
      backdropClassName={styles.backdrop}
      innerContentClassName={styles.ground}
      header={notificationsLabel}
      headerClassName={styles.header}
      {...rest}
    >
      {rest.visible && <AscNotificationContent setVisible={rest.setVisible} />}
    </AscDrawer>
  );
}
